import React from "react";
import { useParams } from "react-router-dom";
import Layout from "../../components/Layout";
import ClaudeAgentChat from "./ClaudeAgentChat";

export default function ClaudeAgentPage() {
  const { agentId } = useParams();
  return (
    <Layout>
      <ClaudeAgentChat initialAgentId={agentId || null} />
    </Layout>
  );
}
